var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"mypage-modal pw",attrs:{"name":"mypage-pw-modal","width":`100%`,"height":`100%`,"pivotY":0.5},on:{"before-close":_vm.handlerBeforeClose,"before-open":_vm.handlerBeforeOpen,"opened":_vm.handlerOpened}},[_c('member-write-component',{attrs:{"member-type":'updatePwd'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }